var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Spinner } from './Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useThemeStyle, getThemeKeyNames } from '../hooks/useThemeStyle';
export var Button = createOverridableComponent('button', function (_a, Component, ref) {
    var busy = _a.busy, children = _a.children, disabled = _a.disabled, icon = _a.icon, collapse = _a.collapse, _b = _a.variant, variant = _b === void 0 ? 'secondary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, props = __rest(_a, ["busy", "children", "disabled", "icon", "collapse", "variant", "size"]);
    var css = useThemeStyle.apply(void 0, __spreadArray(__spreadArray([], getThemeKeyNames({ variant: variant, size: size }, 'buttons'), false), [{
            cursor: 'pointer',
            appearance: 'none',
            textDecoration: 'none',
            fontSize: 2,
            outline: 'none',
            lineHeight: 1.5,
        }], false));
    if (Component === 'button' && !props.type) {
        props.type = 'button';
    }
    return (jsx(Component, __assign({}, props, { ref: ref, disabled: busy || disabled, css: css }),
        icon && (jsx(FontAwesomeIcon, { icon: icon, sx: {
                mr: !children ? 0 : collapse ? [0, 2] : 2,
                display: collapse && busy ? 'none' : '',
            } })),
        children &&
            (collapse ? (jsx("span", { sx: { display: collapse ? ['none', 'inline'] : '' } }, children)) : (children)),
        busy && jsx(Spinner, { sx: { ml: 2 } })));
});
//# sourceMappingURL=Button.js.map